/*
  The table text filter (§6.5), as pure functions.

  It matches the descriptor's filterText — i.e. the VISIBLE, RENDERED columns and nothing
  else. What it replaces is the old row-contains helper in helpers/tables.tsx,
  `JSON.stringify(row).toLowerCase().includes(needle)`, which matched every field the DTO
  carries: ids, image URLs, game codes. A visitor filtering for "12" got rows whose only
  12 is an internal id. Task 11 deleted it once this had taken its last consumer.

  Matching itself is task 5's matchesSearch, so the table filter folds accents exactly
  like the home search does (D17) — "pokemon" finds "Pokémon" in both places or in
  neither.
*/

import { matchesSearch } from "lib";

import { rowFilterText } from "./columns";
import { DataTableColumn } from "./types";

/* A whitespace-only query is someone who has not typed anything yet, not a filter. */
export const isFilterActive = (query: string): boolean => query.trim() !== "";

export const rowMatchesFilter = <TRow>(
  columns: readonly DataTableColumn<TRow>[],
  row: TRow,
  query: string
): boolean => matchesSearch(rowFilterText(columns, row), query);

export const filterRows = <TRow>(
  rows: readonly TRow[],
  columns: readonly DataTableColumn<TRow>[],
  query: string
): TRow[] => {
  if (!isFilterActive(query)) {
    return rows.slice();
  }
  return rows.filter((row) => rowMatchesFilter(columns, row, query));
};
